import React, { useState } from 'react'
import { Container } from './Styled'

// Componentes
import Switch from './Components/Switch/Switch'
import Plano from './Components/Plano/Plano'
import Seta from './Components/Seta/Seta'

export default function Planos ({ dados, lote, planos1Ano, planos2Anos }) {

	const [tipo, setTipo] = useState(2)

	const listaAssinaturas = (tipoPlano, lista, bonus, basica = false) => {
		let listaItens = lista.map((item, index) => (
			<Plano key={index} dadosPlano={item} tipo={tipoPlano} lote={lote} basica={basica ? true : false} bonus={bonus} />
		))
		return listaItens
	}

	const changeSwitch = (tipoPlano) => {
		if (tipoPlano === 1) {
			setTipo(2)
		} else {
			setTipo(1)
		}
	}

	return (
		<React.Fragment>
			{ dados.planos && dados.planos.length > 1 ? <Switch status={tipo} changeSwitch={(plano) => plano ? setTipo(plano) : changeSwitch(tipo)} planos={dados.planos} /> : null }
			<Container>
				{ dados.assinatura_atual ? <Plano dadosPlano={dados.assinatura_atual} atual /> : null }
				{ dados.assinatura_atual && dados.planos.length > 0 ? <Seta /> : null }

				{ tipo === 1 && dados.planos && dados.planos.length > 0 ? listaAssinaturas(2, [planos1Ano[1]], ["+ 6 meses de acesso", "+ 1 meses coaching"]) : null }
				{ tipo === 1 && dados.planos && dados.planos.length > 0 ? listaAssinaturas(2, [planos1Ano[0]], ["+ 3 meses de acesso"], true) : null }
				
				{ tipo === 2 && dados.planos && dados.planos.length > 1 ? listaAssinaturas(2, [planos2Anos[1]], ["+ 6 meses de acesso", "+ 2 meses coaching"]) : null }
				{ tipo === 2 && dados.planos && dados.planos.length > 1 ? listaAssinaturas(2, [planos2Anos[0]], ["+ 3 meses de acesso"], true) : null }
				
			</Container>
		</React.Fragment>
	)
}
